import { createStore } from 'vuex';
import { auth } from './auth.store';
import { user } from './user.store';

const store = createStore({
    modules: {
        auth,
        user,
    },
});

export default store;
